import { lazy } from "react";
import { createFileRoute } from "@tanstack/react-router";

const Kontoinstallningar = lazy(() => import("@/pages/mina-sidor/Kontoinställningar"));

export const Route = createFileRoute("/mina-sidor/kontoinstallningar")({
  component: () => <Kontoinstallningar />,
});
